import { Toast } from "vant";
import { inMobileApp } from "@/utils/mobile/MobileApp";
import { getToken } from "@/utils/request";
import axios from "axios";

function getApiUri() {
  const apiUrlMap = Object.freeze({
    // dev
    "cn-dev": "https://wintogether-tbr-api-dev.gtech.asia/graphql", //"http://10.0.58.42:8080/graphql",SLS00012159898
    "my-dev": "http://speedwork-wm-dev.gtech.asia/graphql",
    // test
    "cn-test": "https://wintogether-tbr-api-test.gtech.asia/graphql",
    "my-test": "https://speedwork-wm-test.gtech.asia/graphql",
    // prod
    "cn-prod": "https://wintogether-tbr-api.cn.gtech.asia/graphql", // "http://wtcn-api.cn.gtech.asia/graphql",
    "my-prod": "http://speedwork-wm.my.gtech.asia/graphql"
  });

  let host = window.location.host;
  const countryMap = {
    malaysia: "my",
    china: "cn",
    id: "id",
    cn: "cn",
    my: "my"
  };
  const countryExec = (
    /(-|\.)(my|cn|malaysia|china|id)/gi.exec(host) || []
  ).slice(2);
  const envExec = (/-(dev|test)/gi.exec(host) || []).slice(1);
  const country = countryMap[countryExec[0]];
  const env = envExec[0] || "prod";
  console.log(country, env, apiUrlMap[`${country}-${env}`]);
  if (!country) {
    return apiUrlMap["cn-dev"];
  }
  return apiUrlMap[`${country}-${env}`];
}

let baseURL = getApiUri();

// 如果是pre测试环境域名，接口名改为对应的接口
if (window.location.host.includes(".gtechcloud")) {
  baseURL = "https://wintogether-tbr-api-test.gtechcloud.cn/graphql";
}

function clearStorage() {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  localStorage.removeItem("userInfo");
}

function ignoreToast(error: any[]) {
  // 忽略提示，自定义提示——请求的时候处理
  if (
    ["speedwork.msg_limit", "createOrderWt.equipmentId"].includes(
      error?.[0]?.code
    )
  ) {
    return true;
  }
  // 直接修改提示
  if (~(error?.[0]?.message?.indexOf("10262001") || -1)) {
    Toast("当前奖励金账户余额不足");
    return true;
  }
  return false;
}

function handlerAxiosError(response: any) {
  let errors: any[] = response.data?.errors;
  if (errors?.length) {
    if (errors[0].code === "0002") {
      Toast(errors[0].message);
      try {
        clearStorage();
        window.nativeApp.signOut();
        window.nativeApp.toLogin();
      } catch {
        // router.push({ name: "login" });
        // window.location.href = "/login";
      }
    } else if (ignoreToast(errors)) {
      // 忽略提示，自定义提示——请求的时候处理
    } else {
      Toast(errors[0]?.message || "系统开小差了~请稍后再试~");
    }
    // throw new Error(JSON.stringify(errors));
    return Promise.reject(JSON.stringify(errors));
  }
}

const createAxiosClient = (): Function => {
  let instance = axios.create({
    baseURL,
    timeout: 60000,
    method: "post"
  });
  // 请求前处理
  instance.interceptors.request.use(async function (config) {
    if (inMobileApp()) await getToken();
    return config;
  });
  // 请求后处理
  instance.interceptors.response.use(
    async function (response) {
      await handlerAxiosError(response);
      return response;
    },
    function (error) {
      // console.log(error, error.message);
      Toast(error.message);
      return Promise.reject(error);
    }
  );

  const packageRequest = function (requestFn: Function): any {
    /**
     * data 请求传参 - 兼容旧版
     * options 自定义axios请求参数
     * options.useGqlType 使用graphql定义的类型（query, mutation）,默认使用query
     */
    return function (data: any = {}, options: any = {}): Promise<any> {
      // 使用请求参数里面定义的graphql类型（query, mutation）
      const GRAPHQL_TYPES = ["query", "mutation"];
      const useGqlType = GRAPHQL_TYPES.find(t => !!data[t]);
      const gql = data[useGqlType];
      const token = localStorage.getItem("token");
      // console.log("token", typeof token, token);
      return requestFn({
        baseURL: baseURL + "?" + gql.name,
        headers: {
          "AUTH-TOKEN": token || "",
          channelCode: "WT",
          Language: window.i18n?.locale
        },
        data: {
          operationName: gql.name,
          [useGqlType]: gql.body,
          variables: data.variables
        },
        ...options
      });
    };
  };
  return packageRequest(instance.request);
};

export const gqlClient: Function = createAxiosClient();
